// extracted by mini-css-extract-plugin
export var europe = "styles-module--europe--2+3Uv";
export var image = "styles-module--image--yIwc6";
export var inner = "styles-module--inner--9sX-6";
export var researchContent = "styles-module--research-content--jdsDn";
export var researchContentItem = "styles-module--research-content-item--I7RwM";
export var researchContentItemText = "styles-module--research-content-item-text--bUccV";
export var researchContentItemTitle = "styles-module--research-content-item-title--Tfr18";
export var videoButton = "styles-module--video-button--PMm7a";